import React, { useState } from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { VrLineHeight } from '../../../../theming/verticalRhythm/verticalRhythm';
import { getGeneratedGlobalStyles } from '../../../../typography/globalTypographyStyles';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';

interface MenuLinkProps {
  linkColor: string
  hoverColor: string
  activeColor: string
  href: string
  text: string
  vrLineHeight: VrLineHeight
  isActive: boolean
  configThemeKey?: string
}

const getWrapperStyle = (vrLineHeight: VrLineHeight) => StyleSheet.create({
  wrapper: {
    [MEDIA_BREAKPOINTS.LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] / 4}px 0`,
    },
    [MEDIA_BREAKPOINTS.X_LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] / 4}px 0`,
    },
  },
});

const getContentStyle = (configThemeKey:string|undefined, hovering:boolean, isActive:boolean) => {
  switch (configThemeKey) {
    case 'editionsMenu':
      return StyleSheet.create(hovering ? getGeneratedGlobalStyles().h4() : getGeneratedGlobalStyles().p());
    case 'moreLinks':
      return StyleSheet.create(isActive ? getGeneratedGlobalStyles().h4() : getGeneratedGlobalStyles().p());
    default: return StyleSheet.create(getGeneratedGlobalStyles().p());
  }
};

export const DropDownMenuLink: React.FunctionComponent<MenuLinkProps> = props => {
  const { linkColor, hoverColor, activeColor, href, text, vrLineHeight, isActive, configThemeKey } = props;
  const [hovering, setHovering] = useState(false);
  const wrapperStyle = getWrapperStyle(vrLineHeight);
  const contentStyle = getContentStyle(configThemeKey, hovering, isActive);
  const linkStyle = generateLinkStyleFromTheme({
    idleColor: isActive ? activeColor : linkColor,
    activeStateColor: activeColor,
    hoverStateColor: isActive ? activeColor : hoverColor,
  }, { width: '100%' });

  return (
    <li onMouseEnter={() => setHovering(true)} onMouseLeave={() => setHovering(false)} className={css(wrapperStyle.wrapper)}>
      <TextLinkComponent href={href} linkStyle={linkStyle}>
        <span className={css(contentStyle.style)}>{text}</span>
      </TextLinkComponent>
    </li>
  );
};
